<template>
	<b-modal ref="modal" size="lg" hide-footer>
		<template v-slot:modal-title>
			{{ $t('invoice.supplier_article_merge_title') }}
		</template>

		<p>{{ $t('invoice.supplier_article_merge_help') }}</p>

		<ul>
			<li v-for="article in absorbed" :key="article.isarticles_id">{{ article.isarticles_label }}</li>
		</ul>

		<div class="form-group">
			<label for="article_merge_target">{{ $t('invoice.supplier_article_merge_target') }}</label>
			<b-form-select id="article_merge_target" v-model="target" :options="target_options" />
		</div>

		<div class="text-center">
			<button class="btn btn-primary" :disabled="target === null || !absorbed.length || processing" @click="merge">
				<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
				{{ $t('invoice.supplier_article_merge_submit') }}
			</button>
		</div>
	</b-modal>
</template>

<script type="text/javascript">
	import Invoice from "@/mixins/Invoice.js"

	export default {
		name: "ArticleMergeModal",
		mixins: [Invoice],
		data() {
			return {
				tiers_id: null,
				// Articles cochés dans le tableau, et tous ceux du fournisseur parmi lesquels choisir la cible.
				selected: [],
				articles: [],
				target: null,
				processing: false
			}
		},
		computed: {
			/**
			 * Articles qui seront absorbés : les articles cochés, hormis la cible si elle en fait partie.
			 * Cocher plusieurs articles puis désigner l'un d'eux suffit ainsi à les réunir.
			 */
			absorbed() {
				return this.selected.filter(article => article.isarticles_id !== this.target)
			},

			/**
			 * Cibles proposées : tous les articles du fournisseur, précédés d'une invite non sélectionnable.
			 */
			target_options() {
				return [
					{ value: null, text: this.$t('invoice.supplier_article_merge_choose'), disabled: true },
					...this.articles.map(article => ({ value: article.isarticles_id, text: article.isarticles_label }))
				]
			}
		},
		methods: {
			/**
			 * Ouvre la modale sur les articles cochés.
			 *
			 * @param {Array} selected Articles cochés dans le tableau.
			 * @param {Array} articles Articles du fournisseur, cibles possibles.
			 * @param {Number} tiers_id Fournisseur des articles.
			 */
			open(selected, articles, tiers_id) {
				this.tiers_id = tiers_id
				this.selected = selected
				this.articles = articles
				this.target = null
				this.processing = false
				this.$refs.modal.show()
			},

			/**
			 * Range les articles absorbés sous la cible, puis prévient l'onglet que sa liste a changé.
			 */
			async merge() {
				this.processing = true

				if(await this.mergeTiersSupplierArticles(this.tiers_id, this.absorbed.map(article => article.isarticles_id), this.target)) {
					this.$refs.modal.hide()
					this.$emit('updated')
				}

				this.processing = false
			}
		}
	}
</script>
